export interface FeatureFlags {
  'onboarding-simplified-sign-up-form-enabled': boolean
}

// maintain a list of all the flags we're interested in here
// along with their default values
export const DefaultFeatureFlags: FeatureFlags = {
  'onboarding-simplified-sign-up-form-enabled': false,
} as const
